import Pagination from '@/blocks.04-project/slider-pagination/slider-pagination.tmpl-specs/base.module';
export default ({ cls = '', images, status = false, attrs, } = {}) => [
	{block: 'product-card', mods: {status: status}, cls: `${cls} product-control`, attrs, content: [
			{elem: 'header', cls: 'product-card-slider', content: [
					{elem: 'header-inner', content: [
							{elem: 'images', tag: 'a', attrs: {href: '#', 'data-url': true, 'data-images': true}, content: [
									{cls: 'swiper', content: [
											{cls: 'swiper-wrapper', content: images.map(({ src, alt }) => [
													{cls: 'swiper-slide', content: [
															{elem: 'img', content: [
																	{block: 'image', mods: {dynamic: true}, cls: 'text-center align-middle', attrs: {width: '300', height: '300'}, content: [
																			{block: 'img', attrs: {loading: 'lazy'}, src: src || './images/default-image/default-image.svg', alt},
																		]},
																]},
														]},
												])},
										]},
								]},
              {elem: 'badges', content: [
                  {elem: 'badges-container', mods: {left: true}, content: [
                      {elem: 'badges-container-item', attrs: {'data-badges-base': true}},
                      {elem: 'badges-container-item', attrs: {'data-badges-technology': true}},
                    ]},
                  {elem: 'badges-container', mods: {right: true}, attrs: {'data-badges-promo': true}},
                ]},
						]},
					{cls: 'text-center', content: [
							Pagination({ count: images.length })
						]},
					{elem: 'status-text', attrs: {'data-status': true}, content: 'Нет в<br>наличии'},
				]},
			{elem: 'title', content: [
					{elem: 'name', tag: 'a', attrs: {href: '#', 'data-title': true, 'data-url': true}, content: 'Лазерная рулетка Reel GM60'},
					{elem: 'article', cls: 'swiper-no-swiping', attrs: { 'data-article': true}, content: 'Арт. 245679'},
				]},
			{elem: 'specs-wrapper', attrs: {'data-specs-preview-container': true}, content: [
					{elem: 'specs', attrs: {'data-specs-preview': true}},
				]},
			{elem: 'feedback', content: [
					{elem: 'rating', tag: 'a', attrs: {href: '#', 'data-rating': true}, content: [
							{block: 'fi', mods: {icon: 'star'}},
							'4.5',
						]},
					{elem: 'reviews', tag: 'a', attrs: {href: '#', 'data-reviews': true}, content: [
							{block: 'fi', mods: {icon: 'chat'}},
							'3',
						]},
				]},
			{elem: 'price', attrs: {'data-out-hide': true, 'data-price': true, 'data-coming-hide': true}, content: [
					'2 400 ₽',
					{tag: 'del', content: '3 800 ₽'}
				]},
			{elem: 'control', content: [
					{elem: 'basket', attrs: {'data-basket': true}, content: [
							{block: 'btn', cls: 'btn-primary btn-lg', tag: 'button', attrs: {'data-out-hide': true, 'data-coming-hide': true}, content: 'В корзину'},
							{block: 'btn', cls: 'btn-primary-light fw-medium', tag: 'button', attrs: {'data-out-visible': true}, content: 'Выбрать похожие'}
						]},
					{elem: 'actions', attrs: {'data-actions': true}, content: [
							{elem: 'action-btn', tag: 'button', attrs: {type: 'button', 'data-control-favorite': true}, content: [
									{block: 'fi', mods: {icon: 'favorite'}},
									{block: 'fi', mods: {icon: 'favorite-fill'}}
								]},
							{elem: 'action-btn', tag: 'button', attrs: {type: 'button', 'data-control-compare': true}, content: [
									{block: 'fi', mods: {icon: 'chart'}},
									{block: 'fi', mods: {icon: 'chart-fill'}},
								]},
						]},
				]}
		]}
];
